import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as FileSaver from 'file-saver';
import { Title } from '@angular/platform-browser';
import { OrderPipe } from 'ngx-order-pipe';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { AppConfig } from 'src/Services/app.config';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { CheckAuth } from 'src/Services/utility.service';
import { IPCSMetrixTableModel, IPCSstateMasterModel, IPCSupdatesModel, IPCSupdatesPageModel, matrixPropery } from 'src/Models/FrontIPCSModel';
import { HtmlToPdf } from 'src/Services/htmlToPdf';
import { FrontIPCSService } from 'src/Services/FrontIPCSService';

@Component({
  selector: 'app-matrix',
  templateUrl: './matrix.component.html',
  styleUrls: ['./matrix.component.css']
})
export class IPCSMatrixComponent implements OnInit {
  isSidePanelActive: boolean = true;
  tokenKey: string = '';
  listOfStateId: string = '';
  listOfData: any[];
  statusCode: any;
  loginUser: any;

  columnName: matrixPropery[];
  columnData: any[];

  listOfState: IPCSstateMasterModel[];

  isRecordFound: boolean = false;

  listOfID: any[];

  isShowprogressSpinner: boolean = true;
  blockedDocument: boolean = true;

  isAscending: boolean = false;
  upDowCSS: string = '';
  colIndex: string;
  OrderBy: string = 'DisplayOrder';
  WhereCondition: string = 'null';
  keyword: string = '';

  OrderByArray = ["DisplayOrder"];

  CustomerComplaintsHandledByIndex: number = -1;
  isColumnAvalible: boolean;
  selectedStateCounter: number;

  matrixData: IPCSMetrixTableModel[];

  UpDownArrowCommissionCertification: string = '';
  UpDownArrowAgencyAssessments: string = '';
  UpDownArrow911: string = '';
  UpDownArrowUSF: string = '';
  UpDownArrowTRS: string = '';
  UpDownArrowOtherFees: string = '';
  UpDownArrowOtherRequirement: string = '';
  UpDownArrow988: string = '';
  isNoRecordFoundCount: number = -1;

  selectAllID: string[];
  isStateRecord: boolean = false;
  chkselectAll: boolean = false;

  appModel: any;
  isKeywordStateSearch: boolean = false;

  updatesModel: IPCSupdatesModel[] = [];
  parameterModel = new IPCSupdatesPageModel();
  isupdatesloading: boolean = false;
  totalupdatesRecordsCount: number = -1;
  statenamepopup: string;
  totalunread: number = 0;
  alldata: string = 'all';
  unreaddata: string = 'unread';
  baseUrl: string;
  sortColumnName: string = '';
  sotingMode: string = ' ASC';
  isColumnClick: boolean = false;

  @ViewChild('divElements', { static: false })
  public divElements: ElementRef;
  isShowPdfButton: boolean = true;
  isDataProcess: boolean = false;

  mainMatrix: IPCSMetrixTableModel[];
  sortedCollection: any[];
  subscriptionArray: any[];
  ClientSelectedTool: string;

  productId:number=41;

  ipcsUnread: number = 0;
  ipcsUnreadflag: boolean = true;

  constructor(private readonly orderPipe: OrderPipe, 
    private readonly titleService: Title, 
    @Inject('BASE_URL') baseUrl: string, 
    private readonly htmlToPdf: HtmlToPdf, 
    private readonly checkAuth: CheckAuth, 
    private readonly router: Router, 
    private readonly ipcsService: FrontIPCSService, 
    private readonly toastr: ToastrService, 
    private readonly appActivity: ApplicationActivityService) {
    this.baseUrl = baseUrl;
    this.listOfStateId = 'null';
    this.listOfData = [];
    this.columnName = [];
    this.columnData = [];
    this.loginUser = sessionStorage.getItem('UserId');
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
    this.listOfID = [];
    this.colIndex = 'StateName';
    this.keyword = '';
    this.isColumnAvalible = false;
    this.selectedStateCounter = 0;
    this.isNoRecordFoundCount = -1;
    this.selectAllID = [];
    this.appModel = AppConfig.settings.ConnectionStrings;
    this.isKeywordStateSearch = false;
    this.ClientSelectedTool = "ipcs";
    this.titleService.setTitle('Matrix | JSi360');
    this.productId=41;

    // Try to get token
    this.waitForTokenThenInit();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  private waitForTokenThenInit(): void {
    this.tokenKey = sessionStorage.getItem('tokenValue');

    if (!this.tokenKey) {
      console.warn('Token is empty, retrying in 100ms...');
      const interval = setInterval(() => {
        this.tokenKey = sessionStorage.getItem('tokenValue');
        if (this.tokenKey) {
          clearInterval(interval);
          this.afterTokenReady();
        }
      }, 100); // check every 100ms
    } else {
      this.afterTokenReady();
    }
  }

  /** Call what you normally do in ngOnInit */
  private afterTokenReady(): void {
    this.unblockDocument();
    this.totalunread = +sessionStorage.getItem(this.unreaddata);
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.GetRightPanelStateList();

    this.GetIPCSUpdatesCount();
  }

  ngOnInit() {
    
  }

  GetMatrix() {
    //this.blockDocument();

    this.isDataProcess = true;
    this.ipcsService.GetIPCSMatrix(this.tokenKey, this.listOfStateId, this.loginUser, this.colIndex, this.OrderBy, this.WhereCondition).subscribe(
      data => {
        this.matrixData = data['matrix'];

        this.mainMatrix = data['matrix'];

        this.sortedCollection = this.orderPipe.transform(this.matrixData, this.OrderBy);

        this.isDataProcess = false;
        if (this.matrixData != null) {
          if (this.matrixData.length > 0) {
            this.isRecordFound = true;
            this.isNoRecordFoundCount = this.matrixData.length;
          }
          else {
            this.isRecordFound = false;
            this.isNoRecordFoundCount = -1;
          }
        }
        else {
          this.isRecordFound = false;
          this.isNoRecordFoundCount = -1;
        }
        let sData = Object.assign([], this.matrixData);
        if (this.listOfID != null) {
          this.matrixData = [];
          if (this.listOfID.length > 0) {
            for (var jCounter = 0; jCounter < this.listOfID.length; jCounter++) {
              for (var iCounter = 0; iCounter < sData.length; iCounter++) {
                if (this.listOfID[jCounter] == sData[iCounter].stateId) {
                  this.matrixData.push(sData[iCounter]);
                }
              }
            }
          }
        }


        if (!this.isKeywordStateSearch && !this.isColumnClick)
          this.unblockDocument();
        this.unblockDocument();
      },
      error => {
        this.statusCode = error;
        this.isDataProcess = false;
      }
    );
    this.isKeywordStateSearch = false;
  }

  ShowHideSidePanel() {
    this.isSidePanelActive = !this.isSidePanelActive;
  }

  GetRightPanelStateList() {
    this.isStateRecord = false;
    this.selectAllID = [];
    this.listOfID = [];

    this.ipcsService.getState(this.tokenKey, this.loginUser, this.productId).subscribe(
      data => {
        this.isStateRecord = true;
        this.selectedStateCounter = 0;
        this.listOfState = data['state'];
        if (this.listOfState != null) {
          let seprator = '';
          if (this.listOfState.length > 0) {
            let IsAnychecked = this.listOfState.filter(m => m.isChecked.toString() == 'true');
           
            this.listOfStateId = '';
            this.isShowPdfButton = true;

            for (let iCounter = 0; iCounter < this.listOfState.length; iCounter++) {
              if (this.listOfState[iCounter].isChecked || IsAnychecked.length == 0) {
                this.listOfState[iCounter].isChecked = true;
                this.selectedStateCounter = this.selectedStateCounter + 1;
                this.listOfID.push(this.listOfState[iCounter].stateId);
                this.listOfStateId += seprator + this.listOfState[iCounter].stateId;
                seprator = ',';

              }
              this.selectAllID.push(this.listOfState[iCounter].stateId)
              if (this.listOfID.length == this.selectAllID.length)
                this.chkselectAll = true;
              else
                this.chkselectAll = false;
            }
          }
          else {
            this.listOfStateId = 'null';
          }
        }
        this.GetMatrix();
      },
      error => {
        this.statusCode = error;
      }
    );
  }

  checkIfSelected(stateId: any, event: any) {
    this.keyword = '';
    this.WhereCondition = 'null';
    if (!event.currentTarget.checked) {
      this.listOfID = this.listOfID.filter(m => m != stateId);
    }
    else {
      this.listOfID.push(stateId);
    }
    this.populateSelectedIdData(this.listOfID);
  }

  populateSelectedIdData(listOfID: any) {
    this.listOfData = [];
    this.columnName = [];
    this.columnData = [];
    this.isRecordFound = false;

    let sData = Object.assign([], this.mainMatrix);
    this.matrixData = [];

    if (this.listOfID != null) {
      let seprator = '';
      if (this.listOfID.length > 0) {
        this.listOfStateId = '';
        for (let iCounter = 0; iCounter < this.listOfID.length; iCounter++) {
          this.listOfStateId += seprator + this.listOfID[iCounter];
          seprator = ',';
          // Find by ID
          if (this.mainMatrix.length > 0) {
            for (var jCounter = 0; jCounter < sData.length; jCounter++) {
              if (sData[jCounter].stateId == this.listOfID[iCounter]) {
                this.matrixData.push(sData[jCounter]);
              }
            }
          }
        }
       
        // 🔥 sort matrixData by listOfState order
        this.matrixData.sort((a, b) => {
          let indexA = this.listOfState.findIndex(s => s.stateId == a.stateId);
          let indexB = this.listOfState.findIndex(s => s.stateId == b.stateId);
          return indexA - indexB;
        });

        this.selectedStateCounter = this.listOfID.length;
        this.isShowPdfButton = true;
      }
      else {
        this.listOfStateId = 'null';
        this.selectedStateCounter = 0;
        this.isShowPdfButton = false;
      }
    }
    this.isKeywordStateSearch = true;
    this.isRecordFound = true;
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  sort(colName: any) {
    if (this.sortColumnName != colName) {
      this.isAscending = true;
    }

    if (this.OrderBy === colName) {
      this.isAscending = !this.isAscending;
    }

    if (this.isAscending)
      this.UpDownArrowCommissionCertification = 'active-up';
    else
      this.UpDownArrowCommissionCertification = 'active';

    this.OrderByArray = [colName, "DisplayOrder"];
    this.OrderBy = colName;
    this.sortColumnName = colName;
  }

  keywordFilters($event) {
    this.listOfData = [];
    this.columnName = [];
    this.columnData = [];
    this.isRecordFound = false;

    if ($event.target.value != "" && $event.target.value != null) {
      this.keyword = $event.target.value;
      this.WhereCondition = $event.target.value;
      if (this.mainMatrix.length > 0) {
        let sData = Object.assign([], this.mainMatrix);
        this.matrixData = [];
        for (var iCounter = 0; iCounter < sData.length; iCounter++) {
          for (var i = 0; i < this.listOfID.length; i++) {
            if (this.listOfID[i] == sData[iCounter].stateId) {
              if (sData[iCounter].name.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1) {
                this.matrixData.push(sData[iCounter]);
              }
            }
          }
        }
      }

    }
    else {
      this.WhereCondition = 'null'
      this.refreshGrid();
    }
    this.isRecordFound = true;
    this.isKeywordStateSearch = true;
  }

  refreshGrid() {
    if (this.mainMatrix.length > 0) {
      let sData = Object.assign([], this.mainMatrix);
      this.matrixData = [];
      for (var iCounter = 0; iCounter < sData.length; iCounter++) {
        for (var i = 0; i < this.listOfID.length; i++) {
          if (this.listOfID[i] == sData[iCounter].stateId) {
            this.matrixData.push(sData[iCounter]);
          }
        }
      }
      this.sortedCollection = this.orderPipe.transform(this.matrixData, 'name');
    }
  }

  clearSearch() {
    this.sortColumnName = '';
    this.UpDownArrowCommissionCertification = '';
    this.UpDownArrowAgencyAssessments = '';
    this.UpDownArrow911 = '';
    this.UpDownArrowUSF = '';
    this.UpDownArrowTRS = '';
    this.UpDownArrowOtherFees = '';
    this.UpDownArrowOtherRequirement = '';
    this.colIndex = 'StateName';
    this.OrderBy = 'DisplayOrder';
    this.OrderByArray = ["DisplayOrder"];
    this.WhereCondition = 'null';
    this.keyword = '';
    this.listOfData = [];
    this.columnName = [];
    this.columnData = [];
    this.isRecordFound = false;
    this.isAscending = false;
    this.UpDownArrow988 = '';
    this.GetRightPanelStateList();
  }

  navigateToFundDetails(stateId: any,stateName: any, AssementCatId: any) {
    this.blockDocument();
    sessionStorage.setItem('singleStatePreview', stateId);
    this.ipcsService.GetIPCSfundRefrence(this.tokenKey, stateId, AssementCatId, this.loginUser).subscribe(
      data => {
        this.unblockDocument();
        let fundTitleReference = data['fundTitleReference'];
        if (fundTitleReference == '')
          fundTitleReference = 'null'

        ApplicationActivityStore('View', 'IPCS PRO - View History', this.appActivity, ToolEnum.ipcs, ActionActivity.IPCS, '/ipcs/Matrix/Fund/Details/' + fundTitleReference,stateName);

        let navigation = '/' + this.ClientSelectedTool + '/Matrix/Fund/Details/' + fundTitleReference;
        this.router.navigate([navigation]);
      },
      error => {
        this.statusCode = error;
        this.unblockDocument();
      }
    );
  }

  openpopup(stateid, statename) {
    this.statenamepopup = statename;
    this.GetUpdates(stateid);
  }

  GetUpdates(stateid): void {
    this.isupdatesloading = true;
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.parameterModel.pageSize = '10';
    this.parameterModel.pageIndex = '1';
    this.parameterModel.keywordFilter = 'null';
    this.parameterModel.whereCondition = ' StateId=' + stateid;
    this.parameterModel.orderBy = 'UpdateDate desc';
    this.parameterModel.fromupdatesDateFilter = "null";
    this.parameterModel.toupdatesDateFilter = "null";
    this.parameterModel.userID = this.loginUser.toString();
    this.parameterModel.updatetype = "null";
    this.parameterModel.unreadonly = "1";
    if (sessionStorage.getItem('isVisibleflag') != '')
      sessionStorage.setItem('isVisibleflag', sessionStorage.getItem('isVisibleflag'));
    else
      sessionStorage.setItem('isVisibleflag', 'true');

    this.ipcsService.getIPCSupdatesfindByUserID(this.tokenKey, this.parameterModel).subscribe(
      data => {
        this.isupdatesloading = false;
        if (data["status"] == "Success") {
          this.updatesModel = data["updates"];
          if (this.updatesModel.length > 0) {
            this.totalupdatesRecordsCount = this.updatesModel.length;
            this.saveNotification(this.updatesModel);
          }
          else {
            this.totalupdatesRecordsCount = 0;
          }
        }
        else {
          this.showMessage('There is an issue while fetching data. Please try again.', 'Error', 'error');
        }
      },
      error => {
        this.statusCode = error;
      },
    );
  }

  saveNotification(updates) {
    let _updates = updates;
    for (let iCounter = 0; iCounter < _updates.length; iCounter++) {
      _updates[iCounter].createdBy = this.loginUser.toString();
    }
    let count = updates.length;
    this.totalunread = +sessionStorage.getItem(this.unreaddata);
    this.ipcsService.AddIIPCSNotification(_updates, this.tokenKey).subscribe(data => {
      if (data.status == 'Success') {
        sessionStorage.setItem(this.unreaddata, ((+this.totalunread) - (+count)).toString());
        this.totalunread = +sessionStorage.getItem(this.unreaddata);

        // Set Update Counter Logic
        if (window.document.body.getElementsByClassName('unread')) {
          if (this.totalunread == 0) {
            window.document.body.getElementsByClassName('unread')[0].setAttribute("style", "display:none");
          }
          else
            window.document.body.getElementsByClassName('unread')[0].innerHTML = this.totalunread.toString();
        }
        this.GetRightPanelStateList();
      }
      else {
        this.showMessage(data.status, 'Error', 'error');
      }
    }, error => {
      this.showMessage(error, 'Error', 'error');
    });
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  selectAllCheckBox(event: any) {
    this.listOfStateId = '';
    this.listOfID = [];
    let allState = Object.assign([], this.listOfState);

    if (!event.currentTarget.checked) {
      this.isShowPdfButton = false;
      // Select checkbox
      if (allState.length > 0) {
        for (var jCounter = 0; jCounter < allState.length; jCounter++) {
          this.listOfState[jCounter].isChecked = false;
        }
      }
    }
    else {
      this.listOfID = this.selectAllID;
      this.isShowPdfButton = true;
      // Select checkbox
      if (allState.length > 0) {
        for (var jCounter = 0; jCounter < allState.length; jCounter++) {
          this.listOfState[jCounter].isChecked = true;
        }
      }
    }

    this.populateSelectedIdData(this.listOfID);
  }

  navigateToFundDetailByName(stateId: any, stateName: any) {
    sessionStorage.setItem('singleStatePreview', stateId);
  
      ApplicationActivityStore('View', 'IPCS PRO - View History', this.appActivity, ToolEnum.ipcs, ActionActivity.IPCS, '/ipcs/Matrix/Fund/Details/', stateName);

    let navigation = '/' + this.ClientSelectedTool + '/Matrix/Fund/Details/' + stateName;
    this.router.navigate([navigation]);
  }

  pdfDocument() {
    this.blockDocument();
    let mainURL = this.baseUrl;
    let url = '<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"> '
    url += ' <link rel="stylesheet" href="' + mainURL + '/assets/css/bootstrap.min.css" asp-append-version="true" /> ';
    url += '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/AdminLTE.min.css"> ';
    url += '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/ionicons.min.css"> ';
    url += '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/jquery-jvectormap.css"> ';
    url += '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/_all-skins.min.css"> ';
    url += '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/_all.css"> ';
    //url += ' <link id="adminstyle" rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"> <br> ';
    var html = url + document.getElementById('divPrint').innerHTML;
    this.htmlToPdf.CreatePDF(this.tokenKey, html, '1',this.productId).
      subscribe(data => {
        if (data['status'] == 'Success') {
          this.downloadFile('Matrix.pdf', data['url'], data['fileName']);
        }
      },
        error => {
          this.statusCode = error;
            this.unblockDocument();
        }
      );
  }

  public downloadFile(filename: any, url: any, orignalFileName: any) {
    this.htmlToPdf.downloadPdf(url).subscribe(
      (res) => {
        FileSaver.saveAs(res, filename);
        
          ApplicationActivityStore('Download', 'IPCS PRO File download ' + filename, this.appActivity, ToolEnum.ipcs, ActionActivity.IPCS, '/ipcs/Matrix');
       
        sessionStorage.setItem('fileloading', 'false');
        this.htmlToPdf.DeletePDF(this.tokenKey, orignalFileName).subscribe(
          data => {
            this.unblockDocument();
          },
        );
      }
    );
  }

  GetIPCSUpdatesCount(): void {
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.parameterModel.pageIndex = '1';
    this.parameterModel.pageSize = '10000';
    this.parameterModel.orderBy = "UpdateDate desc";
    this.parameterModel.keywordFilter = 'null';
    this.parameterModel.whereCondition = 'null';
    this.parameterModel.fromupdatesDateFilter = "null";
    this.parameterModel.toupdatesDateFilter = "null";
    this.parameterModel.userID = sessionStorage.getItem('UserId');
    this.parameterModel.unreadonly = "1";
    this.ipcsUnread = 0;
    this.ipcsService.GetIPCSupdatesfindByUserIDByCount(this.tokenKey, this.parameterModel).subscribe(
      data => {
        if (data["status"] == "Success") {
          this.ipcsUnread = data["updates"];
          sessionStorage.setItem('ipcsUnread', this.ipcsUnread.toString());
          if (this.ipcsUnread > 0) {
            sessionStorage.setItem('ipcsUnreadflag', 'false');
            this.ipcsUnreadflag=false;
          }
        }
      },
      error => {
        this.ipcsUnread = 0;
        sessionStorage.setItem('ipcsUnread', this.ipcsUnread.toString());
      },
    );
  }
}
